import { BRAND } from '@pdf-ticket/shared';

/**
 * /edit route — placeholder editor shell. Phase 1 will replace this with the
 * full mock-v4 editor: navrail + toolbar + viewer + 6-tab inspector.
 */
export function EditRoute() {
  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'grid',
        gridTemplateRows: 'auto 1fr auto',
        background: 'oklch(98% 0 0)',
        color: 'oklch(18% 0 0)',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <header
        style={{
          padding: '0.875rem 1.25rem',
          borderBottom: '1px solid oklch(92% 0 0)',
          background: 'white',
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
        }}
      >
        <strong style={{ fontSize: '1rem' }}>{BRAND.name}</strong>
        <span style={{ fontSize: '0.8125rem', opacity: 0.6 }}>Editor (skeleton)</span>
      </header>
      <main style={{ display: 'grid', placeItems: 'center', padding: '2rem' }}>
        <div
          style={{
            border: '1px dashed oklch(80% 0 0)',
            borderRadius: '0.75rem',
            padding: '3rem 2rem',
            textAlign: 'center',
            maxWidth: '32rem',
          }}
        >
          <p style={{ margin: 0, fontSize: '1rem' }}>
            Phase 0: editor canvas not yet wired.
          </p>
          <p style={{ margin: '0.5rem 0 0', fontSize: '0.8125rem', opacity: 0.65 }}>
            次フェーズでドライバ統合とビューポートを実装します。
          </p>
        </div>
      </main>
      <footer
        style={{
          padding: '0.5rem 1.25rem',
          borderTop: '1px solid oklch(92% 0 0)',
          background: 'white',
          fontSize: '0.75rem',
          opacity: 0.65,
        }}
      >
        {BRAND.domainProduction} · フォント耐性 · 差分のみ保存
      </footer>
    </div>
  );
}
